<template>
  <content-wrapper>
    <Content class="mt-3">
      <b-card header-bg-variant="dark">
        <template #header>
          <b-row class="align-items-center justify-content-between">
            <b-col>
              <h6 class="mb-0">Permits</h6>
            </b-col>
            <b-col md="2" class="d-flex justify-content-end">
              <b-button v-if="can('superadmin')" variant="outline-light" class="mr-2 text-nowrap" @click.prevent="$bvModal.show('bypassModal')">
                By Pass
              </b-button>
              <b-button variant="outline-light" @click.prevent="openPermitForm()">
                <b-icon icon="plus-circle-fill"></b-icon>
                Add
              </b-button>
            </b-col>
          </b-row>
        </template>
        <!-- Table Search -->
        <div class="form-group row" v-if="can('superadmin|control_room')">
          <label class="col-sm-2 col-form-label">Select Member</label>
          <div class="col-sm-10 input-group mb-3">
            <MemberDropDown v-model="selectedMember"
                            :member="member"
                            show-all-members
                            @change="pagination.current = 1;$refs.table.refresh()"
                            v-bind:members.sync="allMembers"
            ></MemberDropDown>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Search</label>
          <div class="col-sm-4 mb-3">
            <b-form-select
                v-model="searchForm.type"
                :options="options.search"
            ></b-form-select>
          </div>
          <div class="col-sm-6 mb-3">
            <b-form-input
                placeholder="Keywords"
                v-model="searchForm.keywords"
                @keydown.enter="search"
            ></b-form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Filter</label>

          <div class="col-md-7 col-sm-10 mb-3">
            <b-row>
              <b-col sm="12" md="4">
                <b-form-select
                    v-model="searchForm.dateType"
                    :options="options.filterDate"
                ></b-form-select>
              </b-col>
              <b-col>
                <b-form-datepicker
                    id="startDate"
                    v-model="searchForm.startDate"
                    :max="searchForm.endDate"
                    locale="en-US"
                    label-no-date-selected="Start Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
              <b-col>
                <b-form-datepicker
                    id="endDate"
                    v-model="searchForm.endDate"
                    locale="en-US"
                    :min="searchForm.startDate"
                    label-no-date-selected="End Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
            </b-row>
          </div>
          <b-col class="d-flex justify-content-between flex-wrap">
                <b-form-radio-group
                    buttons
                    button-variant="outline-primary"
                    :options="options.directions"
                    name="radios-btn-direction"
                    v-model="searchForm.direction"
                    @change="pagination.current=1;$refs.table.refresh()"
                    class="mb-3"
                >
                </b-form-radio-group>
                <b-form-radio-group
                    buttons
                    button-variant="outline-primary"
                    :options="options.status"
                    name="radios-btn-direction"
                    v-model="searchForm.status"
                    @change="pagination.current=1;$refs.table.refresh()"
                    class="mb-3"
                >
                </b-form-radio-group>
          </b-col>
        </div>
        <b-row>
          <b-col offset-sm="10" sm="2" class="mb-3">
            <button type="button" class="btn btn-info btn-block" @click="pagination.current=1;$refs.table.refresh()">
              <i class="fa fa-search"></i> Search
            </button>
          </b-col>
        </b-row>

        <!-- PERMIT TABLE  -->
        <b-table :per-page="pagination.per_page"
                 :current-page="pagination.current"
                 ref="table"
                 id="table"
                 :items="loadPage"
                 :fields="columns"
                 :busy.sync="isLoading"
                 striped
                 borderless
                 outlined
                 hover
                 show-empty
                 empty-text="No records found..."
                 stacked="sm"
                 class="mb-3"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner label="Loading..." type="grow"></b-spinner>
            </div>
          </template>
<!--
          <template #row-details="row">
            <b-card>
              <b-row class="mb-2">
                <b-col
                    md="6"
                    class="mb-1"
                >
                  <dl>
                    <dt>No.Polisi</dt>
                    <dd>{{ row.item.lic_plate }}</dd>
                  </dl>
                  <dl>
                    <dt>Trucking</dt>
                    <dd>{{ row.item.company }}</dd>
                  </dl>
                </b-col>
              </b-row>
            </b-card>
          </template>
-->
          <template #cell(truck)="data">
            {{ data.item.lic_plate != null ? data.item.lic_plate : '' }}
            <b-badge class="text-wrap" variant="warning" v-if="data.item.company != null" >
              {{ data.item.company }}
            </b-badge>
          </template>
          <template #cell(containers)="data">
            <!--￼
            {{ Array.isArray(data.value) ? data.value.length : ( !data.value ? 0 : 1 ) }}
          -->
            <span v-if="typeof data.value === 'object'" >
              <span v-for="(con, index) in ([].concat(data.value.container))" :key="'code'+index" >
                {{ con.no }}&nbsp;
                <b-badge variant="info" >{{ con.voyage }}</b-badge>
              </span>
            </span>
          </template>
          <template #cell(gate)="data">
            <span v-if="data.item.pass_status==3">
              <span v-if="typeof data.item.event === 'object'" >
                <b-badge variant="secondary">{{ data.item.event.evt_time.replace(/T/, ' ').slice(0,19) }}</b-badge>
                <b-badge variant="primary" v-if="data.item.direction==1">{{data.item.event.lane}}</b-badge>
                <b-badge variant="danger" v-if="data.item.direction==2">{{data.item.event.lane}}</b-badge>
              </span>
            </span>
            <span v-if="data.item.pass_status<3">
              <span v-if="typeof data.item.event === 'object'" >
                <b-badge variant="primary" v-if="data.item.direction==1">IN</b-badge>
                <b-badge variant="danger" v-if="data.item.direction==2">OUT</b-badge>
              </span>
            </span>
          </template>
          <template #cell(actions)="data">
            
<!--
              <b-button v-if="data.item.pass_status === 3" variant="info" @click="openPermitForm(data.item)">View</b-button>
-->
              <b-button squared variant="primary btn-sm" @click="openDocumentModal(data.item)">Documents</b-button>
              <b-button squared variant="info btn-sm" @click="showQRModal(data.item)">QRCODE</b-button>
              <b-button squared variant="secondary btn-sm" @click="copyToClipboard(data.item.pass_code)" ><i class="bi bi-clipboard-plus"></i></b-button>
            
          </template>
        </b-table>
        <div class="form-group row justify-content-end">
          <label class="col-sm-1 col-form-label">Per Page</label>
          <div class="col-sm-1 mb-3">
            <b-form-select
                :value="pagination.per_page"
                :options="options.pagination"
                @change="(v) => {pagination.per_page = v; pagination.current = 1}"
            ></b-form-select>
          </div>
          <div class="pr-2">
            <simple-pagination
                v-model="pagination.current"
                :disable-prev="pagination.current === 1"
                :disable-next="pagination.at_last_page"
            />
          </div>
        </div>
      </b-card>
    </Content>


    <!-- By Pass Modal -->
    <b-modal
        centered
        header-bg-variant="info"
        id="bypassModal"
        title="By Pass"
    >
      <b-form-group label="Direction" label-class="required">
        <b-form-radio-group
            v-model="bypassForm.direction"
            :options="options.directions"
            name="bypass-direction"
            buttons
            button-variant="outline-primary"
        ></b-form-radio-group>
      </b-form-group>
      <b-form-group label="No Pol" label-for="bypass-no-pol">
        <b-form-input
            id="bypass-no-pol"
            v-model.trim="bypassForm.no_pol"
            type="text"
            placeholder="Masukkan nomor polisi"
        ></b-form-input>
      </b-form-group>
      <b-list-group v-if="bypassContainers.length > 0" class="mb-3">
        <b-list-group-item
            v-for="(container, index) in bypassContainers"
            :key="`bypass-container-${index}`"
            class="d-flex justify-content-between align-items-center"
        >
          {{ container.container }} - {{ container.voyage }}
          <b-button
              variant="danger"
              size="sm"
              @click="removeBypassContainer(index)"
          >
            Delete
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <b-button
          variant="primary"
          :disabled="bypassContainers.length >= 2"
          @click="$bvModal.show('addContainerModal')"
      >
        Add Container
      </b-button>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" class="text-nowrap" @click="submitBypass">
          By Pass
        </b-button>
        <b-button variant="secondary" @click="resetBypassForm(cancel)">
          Close
        </b-button>
      </template>
    </b-modal>


    <!-- Add Container Modal -->
    <b-modal
        centered
        header-bg-variant="info"
        id="addContainerModal"
        title="Add Container"
        ok-only
        ok-title="Close"
    >
      <b-form-group label="Nomor Container" label-for="bypass-container-number">
        <b-form-input
            id="bypass-container-number"
            v-model.trim="addContainerForm.container"
            type="text"
            placeholder="Masukkan nomor container"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Nomor Voyage" label-for="bypass-voyage-number">
        <b-form-input
            id="bypass-voyage-number"
            v-model.trim="addContainerForm.voyage"
            type="text"
            placeholder="Masukkan nomor voyage"
        ></b-form-input>
      </b-form-group>
          <template #modal-footer="{ cancel }">
            <b-button variant="primary" @click="addBypassContainer">
              Add
            </b-button>
            <b-button variant="secondary" @click="cancel()">
              Close
            </b-button>
          </template>
    </b-modal>


    <!-- PERMIT FORM  -->
    <b-modal
        centered
        header-bg-variant="info"
        id="permitModal" size="lg"
        :title="'Permit Form ' + (this.permit.company !==undefined ? this.permit.company : '')"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
    >
      <b-row>
        <b-col v-if="can('superadmin|control_room')">
          <b-form-group
              label="Owner"
              label-for="owner_name"
          >
            <MemberDropDown v-model="$v.owner.$model"
                            v-if="!isReadOnly"
                            :state="validateState('owner')"

                            type='tes'
                            @input="loadVehicleByMember"
            ></MemberDropDown>
            <b-form-input
                v-else
                :disabled="isReadOnly"
                id="owner_name"
                :readonly="isReadOnly"
                v-model="owner.company_name"
                autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Vehicle"
              label-for="lic_plate"
              label-class="required"
          >
            <b-skeleton-wrapper :loading="isLoadingVehicle">
              <template #loading>
                <b-skeleton type="input"></b-skeleton>
              </template>

              <b-form-input
                  :disabled="options.memberVehicles.length === 0"
                  id="lic_plate"
                  list="vehicle-list"
                  v-model="$v.permit.lic_plate.$model"
                  required
                  :state="validateState('permit', 'lic_plate')"
                  :readonly="readonly.lic_plate"
                  autocomplete="off"
                  v-uppercase
              ></b-form-input>
              <b-form-invalid-feedback>
                This field is required
              </b-form-invalid-feedback>
              <datalist id="vehicle-list">
                <option
                  v-for="vehicle in options.memberVehicles"
                  :key="vehicle.id"
                  :value="vehicle.lic_plate">
                  {{ vehicle.lic_plate }}
                </option>
              </datalist>
            </b-skeleton-wrapper>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Date"
              label-for="date"
              label-class="required"
          >
            <b-form-datepicker
                id="date"
                :aria-disabled="isReadOnly"
                :aria-readonly="isReadOnly"
                v-model="$v.permit.permit_date.$model"
                locale="en-US"
                :state="validateState('permit', 'permit_date')"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <b-form-invalid-feedback>
              This field is required
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <b-form-group class="d-block"
                        label-for="direction"
                        label-class="required"
                        label="Direction"
                        :disabled="isReadOnly"
                        :state="validateState('permit', 'direction')"
          >
            <b-form-radio-group
                v-model="$v.permit.direction.$model"
                :options="options.directions"
                name="radios-btn-direction"
                :state="validateState('permit', 'direction')"
                :disabled="isReadOnly"
            >
              <b-form-invalid-feedback :state="validateState('permit', 'direction')">
                This field is required
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col class="mt-4" v-if="!isReadOnly">
          <div class="d-flex flex-rowr" style="gap:5px;">
            <b-button variant="primary" :disabled="permit.container.length>0" @click="openContainer">
              <i class="fa fa-plus"></i> Container
            </b-button>
            <b-button variant="primary" :disabled="permit.container.length>0" @click="openLooseCargo">
              <i class="fa fa-plus"></i> Loose Cargo
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-collapse id="collapse-container" v-model="isContainerVisible">
        <b-form-group
            label="Container"
            label-for="best"
        >
          <b-input-group>
            <b-form-input
                id="best"
                v-model.trim="$v.container.$model"
                type="text"
                :state="validateState('container')"
                maxLength="15"
                :disabled="permit.container.length===2"
                v-uppercase
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="primary"
                        @click="addContainerToList"
                        :disabled="addingToContainer || permit.container.length === 2"
              >
                <i class="fa fa-plus" v-if="!addingToContainer"></i>
                <i class="fa fa-refresh spinner-border spinner-border-sm" v-else></i>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback>
              This field is required and its max length is 15 characters
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-table
            ref="container"
            id="container"
            :items="permit.container"
            :fields="permitContainer"
            striped
            borderless
            outlined
            hover
            show-empty
            empty-text="Empty container list..."
            stacked="sm"
            class="mb-3"
        >
          <template #cell(action)="data">
            <b-button variant="primary"
                      size="sm"
                      class="mr-3"
                      @click="showContainerInfo({ containers: data.item, direction: permit.direction, status: permit.pass_status })"
            >
              <i class="fa fa-receipt"></i>
              Documents
            </b-button>
            <b-button variant="danger"
                      size="sm"
                      v-if="!isReadOnly"
                      @click="permit.container.splice(data.index,1)"
            >
              <i class="fa fa-trash"></i>
              Delete
            </b-button>
          </template>
        </b-table>
      </b-collapse>

      <b-collapse id="collapse-loosecargo" v-model="isLooseCargoVisible" @input="clearLooseCargo">
        <b-row>
          <b-col cols="12" md="4">
            <b-form-group
                label="No. Surat Jalan"
                label-for="loosecargo-surat-jalan"
            >
              <b-form-input
                  id="loosecargo-surat-jalan"
                  v-model.trim="looseCargoForm.spj_no"
                  type="text"
                  placeholder="Masukkan nomor surat jalan"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group
                label="No. BL"
                label-for="loosecargo-bl"
            >
              <b-form-input
                  id="loosecargo-bl"
                  v-model.trim="looseCargoForm.no_bl_awb"
                  type="text"
                  placeholder="Masukkan nomor BL"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="d-flex align-items-md-end mb-3">
            <b-button variant="primary" block class="text-nowrap" @click="validateLooseCargo" :disabled="isValidatingLooseCargo">
              <b-spinner v-if="isValidatingLooseCargo" small class="mr-1"></b-spinner>
              <i v-else class="fa fa-plus"></i>
              {{ isValidatingLooseCargo ? 'Validating...' : 'Validate' }}
            </b-button>
          </b-col>
        </b-row>
        <b-table
            ref="looseCargo"
            id="looseCargo"
            :items="looseCargoList"
            :fields="looseCargoColumns"
            striped
            borderless
            outlined
            hover
            show-empty
            empty-text="Empty loose cargo list..."
            stacked="lg"
            class="mb-3"
        >
          <template #cell(no)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(action)="data">
            <b-button variant="danger"
                      size="sm"
                      v-if="!isReadOnly"
                      @click="looseCargoList.splice(data.index,1)"
            >
              <i class="fa fa-trash"></i>
              Delete
            </b-button>
          </template>
        </b-table>
      </b-collapse>

      <b-row v-if="!addingToContainer && !!permit.event">
        <b-col>
          <b-badge pill variant="secondary">{{permit.event.lane}}</b-badge>
          <b-badge pill variant="secondary">{{permit.event.evt_time | timestamp}}</b-badge>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel, }">
        <b-button variant="primary"
                  @click="continueToContainerDocuments()"
                  :disabled="isSubmitting || (isContainerVisible && permit.container.length === 0) || (isLooseCargoVisible && looseCargoList.length === 0)"
                  v-if="!isReadOnly"
        >
          Save
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="cancel(); clearForm(); ">
          Cancel
        </b-button>
      </template>
    </b-modal>


    <!-- SPPB Document Modal   -->
    <b-modal
        header-bg-variant="secondary"
        id="sppb" size="xl"
        title="Dokumen Pabean"
        no-close-on-esc
        hide-header-close
        no-close-on-backdrop>

        <span v-for="(con, index) in this.containers" :key="'ctr'+index">
          <b-badge variant="info">
            {{ con.no }}
          </b-badge>
          <b-badge variant="secondary">
            {{ con.voyage }}
          </b-badge>
          <b-table :items="Array.isArray(con.docs)?con.docs:[con.docs]" v-if="!containerIsLoading"
                   :fields="containerColumns"
                   responsive
                   striped
                   borderless
                   outlined
                   hover
                   stacked="sm">
          </b-table>
          <b-skeleton-wrapper :loading="!containerIsLoading">
            <b-skeleton-table
                :rows="5"
                :columns="containerColumns.length"
                :hideHeader="false"
                :table-props="{ bordered: false, striped: true, outlined: true, hover:true, fields: columns, stacked:'sm' }"
            ></b-skeleton-table>
          </b-skeleton-wrapper>
        </span>

      <template #modal-footer="{ ok, cancel, }">
        <b-button v-if="!showContainerInfoOnly" variant="secondary" @click="$bvModal.show('permitModal');cancel()">
          Close
        </b-button>
        <b-button v-if="canCancel" variant="danger" @click="$bvModal.show('cancelConfirmation');canCancel=false;cancel()">
          <i class="fa fa-trash"></i> Cancel this permit!
        </b-button>
        <b-button v-if="showContainerInfoOnly" variant="primary" @click="cancel()">
          Close
        </b-button>
      </template>
    </b-modal>

    <!-- QRCODE Modal -->
    <b-modal header-bg-variant="success"
             id="qrModal"
             :title="(`${selectedPermit.company===undefined?'':selectedPermit.company.toUpperCase()} - `) + (selectedPermit.lic_plate===undefined?'':selectedPermit.lic_plate.toUpperCase())"
             ok-only
             no-close-on-backdrop>
      <h4 class="text-center text-bold text-uppercase">
        {{ selectedPermit.company }}
      </h4>
      <h2 class="text-center">
        {{ selectedPermit.permit_date.replace(/\+.*/, '') }}
      </h2>
      <h1 class="text-center text-uppercase text-bold">
        {{ selectedPermit.direction.toString() === '1' ? 'IN': 'OUT' }}
      </h1>
      <b-link target="_blank" :href="qrcode" @click="copyToClipboard(selectedPermit.pass_code)">
        <b-img :src="qrcode" fluid center></b-img>
      </b-link>
      <h1 class="text-center text-bold text-uppercase">
        {{ selectedPermit.lic_plate }}
      </h1>
      <h2 class="text-center text-uppercase" v-if="selectedPermit.containers!==undefined">
        <ul class="list-group list-group-flush" v-if="selectedPermit.containers!==null">
          <li class="list-group-item" v-for="(container,i) in selectedPermit.containers.container" :key="i">{{ container===undefined?'':container.no }}</li>
        </ul>
      </h2>
      <h2 class="text-center" v-else>
        -
      </h2>
      <template #modal-footer="{ ok, }">
        <b-button @click="qrcode=null;selectedPermit={lic_plate: '',container: '', direction: '', permit_date: '',};ok();" block variant="primary">
          OK!
        </b-button>
      </template>
    </b-modal>

    <!-- Cancel Confirmation Modal -->
    <b-modal header-class="bg-danger text-white" id="cancelConfirmation">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill"></b-icon>
        Cancel Permit Confirmation
      </template>
      <h1 class="text-center font-weight-bolder">WARNING!</h1>
      <h4 class="text-center">This destructive action is not recoverable! </h4>
      <h4 class="text-center">Are you sure to cancel this permit?</h4>
      <b-form-group
          label="Reason"
          label-for="reason"
          label-class="required"
      >
        <b-form-input
            id="reason"
            v-model="$v.cancellationForm.desc.$model"
            :state="validateState('cancellationForm','desc')"
            type="text"
            required
            placeholder="Enter your cancellation reason"
        ></b-form-input>
        <b-form-invalid-feedback>
          This is a required field and max 70 characters.
        </b-form-invalid-feedback>
      </b-form-group>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="outline-danger" @click="cancelPermit(selectedPermit)" :disabled="isCancelling">
          <i class="fa fa-trash"></i>
          Yes, Cancel it!
          <b-spinner v-if="isCancelling" small></b-spinner>
        </b-button>
        <b-button size="sm" variant="secondary" @click="$v.$reset();hide('forget')">
          Nah, I've changed my mind
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import ContentWrapper from "@/components/Layouts/ContentWrapper";
import Content from "@/components/Layouts/Content";
import {listPermit, addPermit, listPermitByVehicle, setPermitStatus} from '@/services/permits';
import {
  BIcon, BIconExclamationTriangleFill, BSkeletonTable,
  BSkeletonWrapper, BFormDatepicker,
  BIconPlusCircleFill, BLink,
} from 'bootstrap-vue'
import {lookupVehicle} from "@/services/vehicles";
import {listBSIMSdoc} from "@/services/bsims";
import {findContainerLocal} from "@/services/bsims";
import {userInfoMixin} from "@/mixins/userInfoMixin";
import SimplePagination from "@/components/SimplePagination";
import {validationMixin} from "vuelidate";
import {formValidation} from "@/mixins/formValidation";
import {required, maxLength,} from "vuelidate/lib/validators";
import Str from "@/helpers/Str";
import MemberDropDown from "@/components/composable/MemberDropDown";
import {optionalMixin} from "@/mixins/optional";
import {hasOwnProperty, isString} from "@/helpers/Utils";
import {
  setPermitBsims,
  bypassPermit,
  bsimsLooseCargolValidate
  // doubleInQrCode
} from "@/services/mware";

export default {
  name: "Permits",
  components: {
    SimplePagination,
    Content, ContentWrapper,
    BSkeletonTable,
    BIcon, 
    //BImg,
    BSkeletonWrapper,
    BFormDatepicker,
    // eslint-disable-next-line vue/no-unused-components
    BIconPlusCircleFill, BIconExclamationTriangleFill,
    MemberDropDown, BLink,
  },
  mixins: [
    userInfoMixin, validationMixin, formValidation,
    optionalMixin,
  ],
  validations: {
    cancellationForm: {
      desc: {
        required,
        maxLength: maxLength(70),
      }
    },
    container: {
      required,
      maxLength: maxLength(15),
    },
    permit: {
      lic_plate: {
        required,
        maxLength: maxLength(9),
      },
      permit_date: {
        required,
      },
      direction: {
        required,
      },  // 1=in 2=out
    },
    owner: {
      required,
    }
  },
  data: () => ({
    bsims_set_permit:{ // set permit payload for bsims
      in_out: 0,
      no_pol: '',
      data: [],
      qrcode: ''
    },
    container_info: {},
    isLoading: false,
    permits: [],
    columns: [
      {
        key: 'permit_date',
        label: 'Tanggal',
        formatter: x => typeof x === 'string' ? x.replace(/\+.*/, '') : '-',
      },
      {
        key: 'truck',
        label: 'Trucking',
      },
      {
        key: 'containers',
        label: 'Container [voy]',
      },
      {
        key: 'gate',
        label: 'Gate',
      },
//      {
//        key: 'direction',
//        label: 'Arah',
//        formatter: x => x === 1 ? 'IN' : 'OUT',
//      },
//      {
//        key: 'event.lane',
//        label: 'jalur',
//        formatter: x => typeof x === 'string' ? x : '-',
//      },
//      {
//        key: 'event.evt_time',
//        label: 'waktu',
//        formatter: x => typeof x === 'string' ? x.replace(/T/, ' ').slice(0,19) : '-',
//      },
      {
        key: 'actions',
        label: 'Actions',
      }
    ],
    pagination: {
      current: 1,
      last_page: 15,
      total_items: 0,
      per_page: 10,
      at_last_page: false,
    },
    permit: {
      lic_plate: "",
//      container: "",
      permit_date: "",
      direction: '',  // 1=in 2=out
      cond: 1,  // 1=kosong 2=isi
      container: [],
    },
    status: {
      false: 'danger', true: 'primary',
    },
    options: {
      directions: [
        {text: 'IN', value: 1},
        {text: 'OUT', value: 2},
      ],
      condition: [
        {text: 'KOSONG', value: 1},
        {text: 'ISI', value: 2},
      ],
      members: [],
      memberVehicles: [],
      search: [
        {text: '', value: ''},
        {text: 'Container', value: 'container'},
        {text: 'License Plate', value: 'lic_plate'},
      ],
      filterDate: [
        {text: '', value: ''},
        {text: 'Gate', value: 'event_time'},
        {text: 'Permit', value: 'permit'},
        {text: 'Activity', value: 'created_at'},
      ],
      pagination: [
        10,
        20,
        30,
        40,
        50,
        80,
        100,
      ],
      status: [
        {text: 'Hold', value: 0},
        {text: 'Active', value: null},
        {text: 'Used', value: 3},
      ],
    },
    owner: null,
    isLoadingVehicle: false,
    containerIsLoading: false,
    containerColumns: [
      {
        key: 'bsims_id',
        label: 'BSIMS',
      },
      {
        key: 'sppb_no',
        label: 'Dok.Pabean',
      },
      {
        key: 'sppb_date',
        label: 'Date',
        formatter: x => x.replace(/1970-01-01\+.*|\+.*/, '')
      },
      {
        key: 'consignee',
        label: 'Consignee',
      },
      {
        key: 'do_no',
        label: 'No. DO',
      },
      {
        key: 'no_bl_awb',
        label: 'No. BL AWB',
      },
      {
        key: 'spj_no',
        label: 'No. SP2',
      },
/*
      {
        key: 'actions',
        label: 'Actions',
      },
 */
    ],
    container: '',
    containers: [],
    documents: [],
    isSubmitting: false,
    selectedDocument: null,
    canAddPermit: false,
    qrcode: '',
    readonly: {
      lic_plate: true,
    },
    showContainerInfoOnly: false,
    isLoadingMember: false,
    searchForm: {
      keywords: null,
      type: null,
      dateType: null,
      startDate: null,
      endDate: null,
      direction: null,
      condition: null,
      status: null,
    },
    selectedPermit: {
      lic_plate: '',
      containers: {
        container: [],
      },
//      container: [],
      permit_date: '',
      direction: '',
      company: '',
    },
    cancellationForm: {
      desc: '',
    },
    isCancelling: false,
    permitContainer: [
      {
        key: 'no',
        label: 'Container',
      },
      {
        key: 'voyage',
        label: 'Voyage',
      },
      {
        key: 'action',
        label: 'Action',
      },
    ],
    canCancel: false,
    isContainerVisible: false,
    isLooseCargoVisible: false,
    isReadOnly: false,
    allMembers: [],
    addingToContainer: false,
    bypassForm: {
      direction: 1,
      no_pol: '',
    },
    addContainerForm: {
      container: '',
      voyage: '',
    },
    bypassContainers: [],
    bypassParams: {},
    looseCargoForm: {
      spj_no: '',
      no_bl_awb: '',
    },
    isValidatingLooseCargo: false,
    looseCargoList: [],
    looseCargoColumns: [
      {
        key: 'no',
        label: 'No.',
      },
      {
        key: 'spj_no',
        label: 'No. SPJ',
      },
      {
        key: 'no_bl_awb',
        label: 'No. BL',
      },
      {
        key: 'no_voy_flight',
        label: 'Voyage',
      },
      {
        key: 'action',
        label: 'Action',
      },
    ],
  }),
  methods: {
    openContainer() {
      this.isLooseCargoVisible = false;
      this.isContainerVisible = !this.isContainerVisible;
    },
    openLooseCargo() {
      this.isContainerVisible = false;
      this.isLooseCargoVisible = !this.isLooseCargoVisible;
    },
    clearLooseCargo() {
      if (!this.isLooseCargoVisible) {
        this.looseCargoForm = {
          spj_no: '',
          no_bl_awb: '',
        };
        this.looseCargoList = [];
        this.isValidatingLooseCargo = false;
      }
    },
    async validateLooseCargo() {
      if (this.isValidatingLooseCargo) {
        return;
      }

      if (!this.looseCargoForm.spj_no || !this.looseCargoForm.no_bl_awb) {
        this.$bvToast.toast('No. Surat Jalan dan No. BL wajib diisi.', {
          title: 'Loose Cargo',
          autoHideDelay: 1500,
          variant: 'danger',
        });
        return;
      }

      //console.log('this.looseCargoList',this.looseCargoList);
      if (this.looseCargoList.some(item => item.no_bl_awb === this.looseCargoForm.no_bl_awb && item.spj_no === this.looseCargoForm.spj_no)) {
        this.$bvToast.toast('Pasangan No. BL dan No. Surat Jalan ini sudah ada dalam daftar Loose Cargo.', {
          title: 'Loose Cargo',
          autoHideDelay: 1500,
          variant: 'danger',
        });
        return;
      }

      this.isValidatingLooseCargo = true;
      try {
        const bsimsResponse = await bsimsLooseCargolValidate(this.looseCargoForm);
        console.log(bsimsResponse);
        if (bsimsResponse.status !== 'success' || !bsimsResponse.data) {
          this.$bvToast.toast(bsimsResponse.message || 'Check B-SIMS App', {
            title: 'Loose Cargo',
            autoHideDelay: 1500,
            variant: 'danger',
          });
          return;
        }

        this.looseCargoList.push({
          spj_no: bsimsResponse.data.spj_no || 'N/A',
          no_bl_awb: bsimsResponse.data.no_bl_awb || 'N/A',
          no_voy_flight: bsimsResponse.data.no_voy_flight || 'N/A',
        });

        this.looseCargoForm = {
          spj_no: '',
          no_bl_awb: '',
        };
        this.$nextTick(() => {
          this.$v.$reset();
        });
        // API validasi loose cargo masih dalam pengembangan oleh BSIMS
        this.$bvToast.toast('Coming soon... The API is currently under development by BSIMS.', {
          title: 'Loose Cargo',
          autoHideDelay: 1500,
          variant: 'warning',
        });
      } catch (error) {
        console.error('Error during bsimsLooseCargolValidate:', error);
        this.$bvToast.toast('Terjadi kesalahan saat validasi Loose Cargo.', {
          title: 'Loose Cargo',
          autoHideDelay: 1500,
          variant: 'danger',
        });
      } finally {
        this.isValidatingLooseCargo = false;
      }
    },
    resetBypassForm(cancel) {
      this.bypassForm = {
        direction: 1,
        no_pol: '',
      };
      this.bypassContainers = [];
      this.addContainerForm = {
        container: '',
        voyage: '',
      };
      this.bypassParams = {};
      cancel();
    },
    async submitBypass() {
      if (![1, 2].includes(this.bypassForm.direction)) {
        this.$bvToast.toast('Direction wajib dipilih.', {
          title: 'By Pass',
          autoHideDelay: 1500,
          variant: 'danger',
        });
        return;
      }

      if (!this.bypassForm.no_pol) {
        this.$bvToast.toast('No Pol wajib diisi.', {
          title: 'By Pass',
          autoHideDelay: 1500,
          variant: 'danger',
        });
        return;
      }

      if (this.bypassContainers.length === 0) {
        this.$bvToast.toast('Minimal satu container wajib ditambahkan.', {
          title: 'By Pass',
          autoHideDelay: 1500,
          variant: 'danger',
        });
        return;
      }

      const params = {
        direction: this.bypassForm.direction,
        lic_plate: this.bypassForm.no_pol,
        container: this.bypassContainers.map(container => ({
          no: container.container,
          voyage: container.voyage,
        })),
      };
      this.bypassParams = params;

      try {
        const response = JSON.parse(await bypassPermit(params));
        console.log('bypassPermit response', response);
        if (response.status === 'success') {
          this.$bvToast.toast('Data By Pass berhasil divalidasi.', {
            title: 'By Pass',
            autoHideDelay: 1500,
            variant: 'success',
          });
        }else{
          this.$bvToast.toast(`By Pass gagal: ${response.message}`, {
            title: 'By Pass',
            autoHideDelay: 1500,
            variant: 'danger',
          });
        }
      } catch (error) {
        console.error('Error during bypassPermit:', error);
        this.$bvToast.toast('Terjadi kesalahan saat memproses By Pass.', {
          title: 'By Pass',
          autoHideDelay: 1500,
          variant: 'danger',
        });
        return;
      }
    },
    removeBypassContainer(index) {
      this.bypassContainers.splice(index, 1);
    },
    addBypassContainer() {
      if (!this.addContainerForm.container || !this.addContainerForm.voyage) {
        this.$bvToast.toast('Nomor container dan voyage wajib diisi.', {
          title: 'By Pass',
          autoHideDelay: 1500,
          variant: 'danger',
        });
        return;
      }

      this.bypassContainers.push({ ...this.addContainerForm });
      this.addContainerForm = { container: '', voyage: '' };
      this.$bvModal.hide('addContainerModal');
    },
    async loadPage(ctx) {
      this.isLoading = true;
      this.pagination.total_items = 0;
      this.pagination.at_last_page = false;
      try {
        const {data: {data: {rows}}} = await listPermit(this.searchParams(ctx));
        this.isLoading = false;
        const items = Array.isArray(rows.permit) ? rows.permit : [rows.permit];
        this.pagination.total_items = items.length
        this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;
        return items;
      } catch (e) {
        this.isLoading = false;
        this.pagination.at_last_page = true;
        return [];
      }
    },
    openPermitForm(permit) {
      this.clearForm()
      this.options.memberVehicles = [];
      if (this.can('memberadmin|member')) {
        this.owner = {
          id: this.member.id,
          company_name: this.member.company_name,
//          company_name: permit.company,
        }
        this.$nextTick(() => {
          this.$v.owner.$touch()
        });
        this.loadVehicleByMember()
      }
      if (permit !== undefined) {
        this.isReadOnly = true;
        this.$v.permit.$model = { ... permit};
        this.permit.permit_date = this.permit.permit_date.replace(/\+.*/, '')
        let container = this.optional(this.permit, 'container', []);
        if (container && isString(container)) {
          container = [container]
        }
        this.permit.container = container.map(c => ({ container: c }))

//        this.$v.owner.$model = permit.company;
//        this.$bvToast.toast(`INFO:  ${value} ${permit.member}`, {
//          title: 'Show field value !',
//          autoHideDelay: 1500,
//          variant: 'danger',
//        })

//        if (this.allMembers.length > 0) {
//          const { value } = this.allMembers.find(m => m.value.id === permit.member)
//          this.$v.owner.$model = value;
//        }
        this.isContainerVisible = true;
      }
      this.$bvModal.show('permitModal')
    },
    openDocumentModal(permit) {
      this.selectedPermit = { ...permit};

      if ( this.selectedPermit.containers === null ) {
        this.$bvToast.toast(`No Container !`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }

      this.permit.container = Array.isArray(this.selectedPermit.containers.container) ? this.selectedPermit.containers.container.join(',') : this.selectedPermit.containers.container;
      this.showContainerInfoOnly = this.canCancel = true;
      if( this.selectedPermit.event === null ) {
        this.showContainerInfo({ containers: this.selectedPermit.containers, direction: this.selectedPermit.direction, status: this.selectedPermit.pass_status });
      } else {
        this.showContainerInfo({ containers: this.selectedPermit.containers, direction: this.selectedPermit.direction, status: this.selectedPermit.pass_status, event: this.selectedPermit.event.id });
      }
    },
    async addPermit() {
      if (!this.canAddPermit) {
        this.$bvToast.toast(`You are not allowed to add Permit!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.$v.permit.$touch();
      if (this.$v.permit.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.isSubmitting = true;

      // double in qrcode
      /*
      try {
        let double_qr = JSON.parse(await doubleInQrCode({ direction: this.permit.direction, no_pol: this.permit.lic_plate }));
        console.log('double_qr', double_qr);

        // test double qr code response
        // this.isSubmitting = false;
        // return;

        if (double_qr.bool) {
          this.$bvToast.toast(`${double_qr.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          this.isSubmitting = false;
          return;
        }
      } catch (e) {
        // do nothing since the check is only optional
        this.$bvToast.toast(`Failed to check double in permit, please contact the administrator!`, {
          title: 'Warning!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      */

      try {
        // Some fields are default from now, refer to addPermit service and see for default value
        // @see @/services/permit.js
        const data = { ... this.permit };
        data.user_id = this.loggedInUser.id;
        data.user_name = this.loggedInUser.username
        const {data: {data: {pass}}} = await addPermit(data);
        console.log('addPermit pass', pass);
        this.selectedPermit.containers = { container: [] };
        if( data.container != null ) {
          if (!Array.isArray(data.container)) {
            this.selectedPermit.containers.container = [data.container];
          } else {
            this.selectedPermit.containers.container = data.container;
          }
        }
        this.selectedPermit.lic_plate = this.permit.lic_plate;
        this.selectedPermit.direction = data.direction;
        this.selectedPermit.company = this.owner.company_name;
        this.selectedPermit.permit_date = pass.permit_date;
        this.qrcode = `/static/qrcode/${pass.qr_code}`;
        this.$bvToast.toast(`Add Permit Success!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.$bvModal.hide('permitModal')
        this.$bvModal.hide('sppb');
        this.$bvModal.show('qrModal')

        // set permit
        if (this.selectedPermit.containers.container.length > 0) {
          this.bsims_set_permit.qrcode = pass.qr_code;
          const set_permit_bsims = JSON.parse(await setPermitBsims(this.bsims_set_permit));
          console.log('setP addPermit', set_permit_bsims);
        }

        this.clearForm();
        this.$refs.table.refresh();
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
      this.isSubmitting = false;
    },
    clearForm() {
      this.bsims_set_permit = { // set permit default value
        in_out: 0,
        no_pol: '',
        data: [],
        qrcode: ''
      };
      this.container = '';
      this.permit = {
        lic_plate: "",
        // container: "",
        permit_date: "",
        direction: '',  // 1=in 2=out
        cond: 1,  // 1=kosong 2=isi
        container: [],
      }
      this.isContainerVisible = false;
      this.isLooseCargoVisible = false;
      this.selectedDocument = null;
      this.owner = null;
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.isReadOnly = false;
    },
    async loadVehicleByMember() {
      try {
        this.isLoadingVehicle = true;
        this.readonly.lic_plate = true;
        this.permit.lic_plate = '';

        if(this.owner.text){
          this.owner = this.owner.value
        }
        console.log('this.owner', this.owner);
        const {data: {data: {rows}}} = await lookupVehicle({member: this.owner.id});
        console.log('rows', rows);
        this.options.memberVehicles = Array.isArray(rows.vehicle) ? rows.vehicle : [rows.vehicle];
        console.log('this.options.memberVehicles', this.options.memberVehicles);
        
        this.readonly.lic_plate = false;
      } catch (e) {
        this.options.memberVehicles = [];
      }
      this.isLoadingVehicle = false;
    },
    async continueToContainerDocuments() {
      console.log('continueToContainerDocuments');
      /**
       * Need extra confirmation from Pak.Halim
       * about how to submit this form
       * since the initial API only accept 1 or non container
       * and now it becomes 1 or 2 or non
       */
      this.canAddPermit = true;
      return this.addPermit();
      // eslint-disable-next-line no-unreachable
      // this.showContainerInfoOnly = false;
      // this.$v.permit.$touch();
      // if (this.$v.permit.$anyError) {
      //   this.$bvToast.toast(`Missing required information!`, {
      //     title: 'Error!',
      //     autoHideDelay: 1500,
      //     variant: 'danger',
      //   })
      //   return;
      // }
      // if (!this.permit.container) {
      //   // only when the container is empty, it allowed to directly create permit!
      //   this.canAddPermit = true;
      //   return this.addPermit();
      // }
      // this.$bvModal.hide('permitModal')
      // return this.showContainerInfo(this.permit.container);
    },
    async showContainerInfo({ containers, direction, status, event }) {

      this.$bvToast.toast(`STATUS:  ${containers} ${status}`, {
          title: 'Show field value !',
          autoHideDelay: 1500,
          variant: 'danger',
      })

      this.containerIsLoading = true;
      if (!containers) {
        this.containerIsLoading = false;
        this.documents = [];
        this.canAddPermit = false;
        return;
      }

      this.containers = [];

      for( const c of Array.isArray(containers.container)?containers.container:[containers.container] ) {
        try {
          const {data: {data: {container}}} = event === undefined ?
            await listBSIMSdoc({
              container: c.no,
              voyage: c.voyage,
              direction: direction,
              status: 0,
              // status: (status === 3 ? 1 : 0 ),
              format: 'container',
            }) :
            await listBSIMSdoc({
              container: c.no,
              voyage: c.voyage,
              direction: direction,
              status: 1,
              event: event,
              // status: (status === 3 ? 1 : 0 ),
              format: 'container',
            });

          this.containers.push(container);

          // if (Array.isArray(container.docs)) {
          //   this.documents = container.docs.map(c => Array.isArray(c.docs) ? c.docs : [c.docs]).flat()
          // } else {
          //   this.container_info = container;
          //   this.documents = Array.isArray(container.docs) ? container.docs : [container.docs];
          // }
          // this.canAddPermit = true;

        } catch (e) {
          console.error(e)
          this.documents = [];
          this.canAddPermit = false;
          return;
        }

      }
      this.$bvModal.show('sppb');
      this.containerIsLoading = false;
    },
    /**
     * this method will be completely removed on next release
     * @deprecated
     * @type {boolean}
     */
    selectDocument(doc) {
      this.selectedDocument = doc;
      this.$bvModal.hide('sppb')
    },
    /**
     * this method will be completely removed on next release
     * @deprecated
     * @type {boolean}
     */
    async search() {
      this.isLoading = true;
      try {
        const {data: {data: {rows}}} = await listPermitByVehicle(this.searchParams());
        this.permits = Array.isArray(rows.permit) ? rows.permit : [rows.permit];
      } catch (e) {
        this.permits = [];
      }
      this.isLoading = false;
    },
    searchParams(ctx) {
      const searchData = {
        per_page: this.pagination.per_page,
        current_page: this.pagination.current,
      };
      if (ctx.sortBy !== '') {
        const direction = ctx.sortDesc ? 'desc' : 'asc';
        searchData['order_by'] = `${ctx.sortBy},${direction}`;
      }
      if (this.selectedMember !== null) {
        searchData['member'] = this.selectedMember.id
      }
      if (this.selectedMember === '' && Object.prototype.hasOwnProperty.call(searchData, 'member')) {
        delete searchData.member
      }
      if (this.searchForm.type) {
        searchData[this.searchForm.type] = `%${this.searchForm.keywords}%`;
      }

      if (this.searchForm.dateType && this.searchForm.startDate) {
        searchData[`${this.searchForm.dateType}_start`] = this.searchForm.startDate;
      }
      if (this.searchForm.dateType && this.searchForm.endDate) {
        searchData[`${this.searchForm.dateType}_end`] = this.searchForm.endDate;
      }
      if (this.searchForm.direction) {
        searchData['direction'] = this.searchForm.direction;
      }
      if (this.searchForm.condition) {
        searchData['cond'] = this.searchForm.condition;
      }
      if (this.searchForm.status !== null) {
        searchData['status'] = this.searchForm.status;
      }
      return searchData;
    },
    showQRModal(permit) {
      if (!hasOwnProperty(permit, 'pass_code')) {
        this.$bvToast.toast(`QRCode does not exists`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.qrcode = `/static/qrcode/${permit.pass_code}`;
      this.selectedPermit = { ...permit };
      if( this.selectedPermit.containers !== null ) {
        if (!Array.isArray(this.selectedPermit.containers.container)) {
          this.selectedPermit.containers.container = [this.selectedPermit.containers.container]
        }
      }
      this.$bvModal.show('qrModal');
    },
    async copyToClipboard(qrcode) {
      if (!qrcode) {
        this.$bvToast.toast(`QRCode does not exists`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      const url = new URL(window.location.href);
      const text = `${url.origin}/static/qrcode/${qrcode}`;
      await this.$copyText(text)
      this.$bvToast.toast(`Code [${text}] copied`, {
        title: 'Success!',
        autoHideDelay: 1500,
        variant: 'success',
      })
    },
    async cancelPermit(permit) {
      this.isCancelling = true;
      try {
        this.$v.cancellationForm.$touch();
        if (this.$v.cancellationForm.$anyError) {
          this.$bvToast.toast(`Missing required information!`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }

        const data = {
          permit_id: permit.id,
          status: 0,
          username: this.loggedInUser.username,
          desc: this.cancellationForm.desc,
        }
        await setPermitStatus(data);
        this.isCancelling = false
        this.$nextTick(() => {
          this.$v.$reset();
        });
        this.$bvModal.hide('cancelConfirmation');
        this.$refs.table.refresh();
      } catch (e) {
        this.isCancelling = false
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
    async addContainerToList(){
      this.$v.container.$touch();
      if (this.$v.container.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.addingToContainer = true;
      this.container = Str.removeAllWhitespaces(this.container)
      const exists = this.permit.container.filter(({container}) => container === this.container)
      if (exists.length > 0) {
        this.$bvToast.toast(`Container ${this.container} already in the list!`, {
          title: 'Duplication Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        this.addingToContainer = false;
        return;
      }
      try {
        const {data: {data: {rows}}} = await findContainerLocal({
          container: this.container,
          direction: this.permit.direction,
          status: 0,
        });
        this.permit.container.push({ no: rows.container.no, voyage: rows.container.voyage });

        // set permit payload for bsims
        console.log('rows TEST', rows);
        this.bsims_set_permit.in_out = rows.container.direction;
        this.bsims_set_permit.no_pol = this.permit.lic_plate;

        this.bsims_set_permit.data = [...this.bsims_set_permit.data, rows.container];
        console.log('addContainerToList TEST', this.bsims_set_permit);

        // set permit testing matikan yang bawah
        // this.bsims_set_permit.qrcode = 'l5s9p6ftxkpyavmzj8h0ho';
        // const set_permit_bsims = JSON.parse(await setPermitBsims(this.bsims_set_permit));
        // console.log('setP now', set_permit_bsims);
        

        this.container = null;
        this.$nextTick(() => {
          this.$v.container.$reset();
        });
        this.addingToContainer = false;
      } catch (e) {
        this.addingToContainer = false;
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
